import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-b",
  "use": "arrow-b-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-b\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.668 9.507A.48.48 0 008 9.636a.459.459 0 00.329-.129c1.025-.976 1.912-1.945 2.888-2.942a.202.202 0 00-.143-.343H4.918a.2.2 0 00-.144.34c.969 1.004 1.87 1.97 2.894 2.945z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol